import styled from 'styled-components';
import color from './configs/color';

const AppWrapper = styled.div`
  min-height: 100vh;
  font-family: Khula;
  .ant-spin {
    display: flex;
    justify-content: center;
    margin-top: 60px;
  }

  .black1 {
    color: ${color.black1};
  }
  .black2 {
    color: ${color.black2};
  }
  .black3 {
    color: ${color.black3};
  }
  .black4 {
    color: ${color.black4};
  }
  .orange1 {
    color: ${color.orange1};
  }
  .red1 {
    color: ${color.red1};
  }
  .red2 {
    color: ${color.red2};
  }
  .orange {
    color: ${color.orange1};
  }
  .green1 {
    color: ${color.green1};
  }
  .anticon {
    &.purple {
      color: ${color.purple1};
      background-color: ${color.grey3};
    }
    &.orange {
      color: ${color.orange1};
      background-color: ${color.orange6};
    }
  }
  .pointer {
    cursor: pointer;
  }
`;

export default AppWrapper;
